/* eslint-disable react-hooks/exhaustive-deps */
import Constant from '@/common/constant/Constant';
import Utils from '@/common/utils/utils';
import { corporationAtom } from '@/state/atom/corporationAtom';
import { IconButton, Table, TableBody, TableCell, TableRow } from '@material-ui/core';
import { Fragment, useEffect, useState } from 'react';
import { useRecoilState, useRecoilValue, useSetRecoilState } from 'recoil';
import '../system/UserManagement.css';
import '../system/dialog/ConfirmDeleteOrgUserDialog.css';
import OverFlowTooltipWithCustomCss from '../common/OverFlowTooltipWithCustomCss';
import LoadingPanel from '../common/LoadingPanel';
import organizationService, { getListAllCorporation } from '@/service/organizationService';
import { closePanelTabSelector, setPanelSelector } from '@/state/selector/panelSelector';
import { multiPanelAtom, reloadEditContractTabIdAtom } from '@/state/atom/panelAtom';
import ConfirmDialog from '@/common/dialog/ConfirmDialog';
import { useSnackbar } from 'notistack';
import { getOrgStatus, isDisplayWarningIcon } from './EditOrganizationHandler';
import MoreActionListOrg from './element/MoreActionListOrg'
import { displayContractStatus, handleClickExpand, handleClickShareStatus, isDisplayWarningForContractStatus } from './ListOrganizationHandler';
import CollapseListOrg from './element/CollapseListOrg';
import { userAtom } from '@/state/atom/userAtom';

import PropTypes from 'prop-types';
import trI18n from '@/common/utils/trI18n';
import { tr } from '@/common/utils/tr';
import { useTranslationSubscription } from '@/hooks/useTranslation';
import { buildSnackbarMessage } from '@/component/common/SnackbarMessage';


ListOrganization.propTypes = {
    API: PropTypes.any,
    panelType: PropTypes.any,
    triggerReload: PropTypes.any
};


export default function ListOrganization(props) {
    // Re-render when the translation dictionary loads/extends so tr() text updates.
    useTranslationSubscription();

    const corporationDetail = useRecoilValue(corporationAtom);
    const currentUserDetail = useRecoilValue(userAtom);
    const [orgList, setOrgList] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const addNewPanel = useSetRecoilState(setPanelSelector);
    const [panelList, setPanelList] = useRecoilState(multiPanelAtom);
    const [isOpenPopupConfirmBlock, setIsPopupConfirmBlock] = useState(false);
    const [isOpenPopupConfirmUnlock, setIsPopupConfirmUnlock] = useState(false);
    const [isOpenPopupConfirmDelete, setIsOpenPopupConfirmDelete] = useState(false);
    const [isOpenPopupConfirmOffRootOrg, setIsPopupConfirmOffRootOrg] = useState(false);
    const [isOpenPopupConfirmOnRootOrg, setIsPopupConfirmOnRootOrg] = useState(false);
    const [reloadEditContractTabId,setReloadEditContractTabId] = useRecoilState(reloadEditContractTabIdAtom)
    const closePanelTab = useSetRecoilState(closePanelTabSelector);
    const [isOpenPopupCantNotDelete,setIsOpenPopupCantNotDelete] = useState(false)
    const { enqueueSnackbar, closeSnackbar } = useSnackbar();
    const [clickedOrg, setClickedOrg] = useState('');
    const [moreAction, setMoreAction] = useState(null);
    const [openShareStatusPopover, setOpenShareStatusPopover] = useState('');
    const [openGroupPartnerOrSp, setOpenGroupPartnerOrSp] = useState('');
    const [isShowPopUpReload, setIsShowPopUpReload] = useState({isOpen: false, message: ''});
    const addNewTab = (id, orgName) => {
        addNewPanel({
            type: Constant.PANEL_TYPE.ROOT_ORG_EDIT_CONTRACT,
            tabId: id,
            props,
            orgId: id,
            orgName: orgName
        });
    };
    useEffect(() => {
        if (!Utils.isEmptyString(corporationDetail.id)) {
            if (corporationDetail.rootFlag !== 1) {
                let newPanelList = panelList?.filter(
                    panel =>
                        panel.type !== props.panelType &&
                        panel.type !== Constant.PANEL_TYPE.ROOT_ORG_EDIT_CONTRACT
                );
                setPanelList([...newPanelList]);
            }
        }
    }, [corporationDetail]);

    useEffect(() => {
        let isMounted = true;
        setIsLoading(true);

        getListAllCorporation(props?.API)
            .then(result => {
                if (!isMounted) return;

                let listOrg = [];
                let listOrgNew = []
                result?.forEach(org => {
                    if (org.active !== Constant.CORPORATION_ACTIVE.DELETED) {
                        let orgClone = { ...org };
                        if (!Utils.isEmptyString(orgClone.image)) {
                            const corporationLogo = Utils.getCloudFrontUrlForCorporationLogo({
                                type: Constant.S3_FILE_TYPE.CORPORATION_LOGO_PROFILE_FILE,
                                image: orgClone.image,
                                corporationId: orgClone.organizationDomain,
                                corporationDetail: orgClone
                            });
                            orgClone.corporationLogo = corporationLogo;
                        } else {
                            orgClone.corporationLogo = Constant.LOGO_DEFAULT;
                        }
                        orgClone.contractType =
                            orgClone.contractType === Constant.CORPORATION_CONTRACT_TYPE.PREMIUM
                                ? Constant.CORPORATION_CONTRACT_TYPE.STANDARD
                                : orgClone.contractType;
                        orgClone.contractName = organizationService.convertContractTypeToJPName(
                            orgClone.contractType
                        );
                        listOrg.push(orgClone);
                    }
                });
                listOrg = Utils.sortByCreatedAtDesc(listOrg)

                let listOrgHasNotInviter = listOrg.filter(item => Utils.isEmptyString(item.inviter));
                let listOrgHasInviter = listOrg.filter(item => !Utils.isEmptyString(item.inviter));
                listOrgHasNotInviter?.forEach(org => {
                    let orgClone = { ...org };
                    if (!Utils.isEmptyArray(orgClone.corporationInvited)) {
                        orgClone.groupPartnerOrSp = listOrgHasInviter.filter(item => item.inviter == orgClone.id)
                    }

                    listOrgNew.push(orgClone);
                })
                listOrgNew = Utils.sortByCreatedAtDesc(listOrgNew);
                if (isMounted) {
                    setOrgList([...listOrgNew]);
                    setIsLoading(false);
                }
            })
            .catch(error => {
                console.log('getListAllCorporation err: ', error);
                if (isMounted) {
                    setIsLoading(false);
                }
            });

        return () => {
            isMounted = false;
        };
    }, [props.triggerReload]);

    
    const customStyle = {
        color: '#2E3138',
        fontFamily: 'Zen Kaku Gothic New',
        fontStyle: 'normal',
        fontWeight: '500',
        fontSize: '15px',
        lineHeight: '16px',
        width: '137px',
        height: '18px',
        cursor: 'pointer'
    };

    const onClickBlockOrg = id => {
        setClickedOrg(id);
        setIsPopupConfirmBlock(true);
    };

    const onClickChangePermission = org => {
        if (isDisableChangeRootOrg(org)) {
            return ''
        }
        setClickedOrg(org);
        if (org.rootFlag === Constant.ROOT_FLAG.TRUE) {
            setIsPopupConfirmOffRootOrg(true);
        } else {
            setIsPopupConfirmOnRootOrg(true);
        }
    };

    const onClickUnlockOrg = id => {
        setClickedOrg(id);
        setIsPopupConfirmUnlock(true);
    };

    const onClickDeleteOrg = (id) => {
        setClickedOrg(id);
        setIsOpenPopupConfirmDelete(true)
    }

    const onSubmitDeleteOrg = async() => {
        setIsOpenPopupConfirmDelete(false)
        setIsLoading(true);
        const orgId = clickedOrg;
        const deleteResult = await organizationService.blockAndDeleteOrg(props?.API, orgId, 'DELETE', currentUserDetail.id);
        if(!deleteResult.success){
            if (deleteResult.errors === Constant.DATA_CHANGED_PLEASE_RELOAD_ERROR) {
                setIsShowPopUpReload({
                    isOpen: true,
                    message: 'COMMSG030'
                });
            } else {
                setIsOpenPopupCantNotDelete(true)
            }
            setIsLoading(false);
            return;
        }
        enqueueSnackbar(buildSnackbarMessage('COMMSG045'), {
            variant: 'success',
            autoHideDuration: 3000,
        });
        const panelEditContract = panelList.find(panel => panel.type === Constant.PANEL_TYPE.ROOT_ORG_EDIT_CONTRACT)
        if(!Utils.isEmptyObject(panelEditContract)){
            let tabList = panelEditContract.tabList
            let tabOfDeleteOrg = tabList.find(tab => tab.id === orgId)
            if(!Utils.isEmptyObject(tabOfDeleteOrg)){
                closePanelTab({
                    event: null,
                    panelType: Constant.PANEL_TYPE.ROOT_ORG_EDIT_CONTRACT,
                    panelId: panelEditContract.id,
                    tabId: tabOfDeleteOrg.id
                })  
            }
        }
        updateListOrgAfterDeleteOrg(orgId)
        setClickedOrg('');
        setIsLoading(false);
    }

    const onSubmitChangeRootFlag = async () => {
        const requestDto = {
            id: clickedOrg.id,
            rootFlag: typeof clickedOrg.rootFlag === 'number' ? clickedOrg.rootFlag : 0
        }
        if (requestDto.rootFlag === Constant.ROOT_FLAG.TRUE) {
            setIsPopupConfirmOffRootOrg(false);
        } else {
            setIsPopupConfirmOnRootOrg(false);
        }
        setIsLoading(true);
        const result = await organizationService.updateRootOrganizationPermissionById(props?.API, requestDto);

        if (Utils.isEmpty(result.id)) {
            setIsShowPopUpReload({isOpen: true, message: 'COMMSG030'});
            setIsLoading(false);
            return;
        }

        if (result) {
            updatePermissionOrgAfterChangeRoot(result)
            enqueueSnackbar(buildSnackbarMessage('COMMSG045'), {
                variant: 'success',
                autoHideDuration: 3000,
            });
        }
        setIsLoading(false);
    }

    const isResponseError = (result) => {
        return result &&
            typeof result === 'object' &&
            result.hasOwnProperty('success') && 
            result.success === false
    }

    const onSubmitUnlockOrg = async () => {
        setIsPopupConfirmUnlock(false);
        const orgId = clickedOrg;
        setIsLoading(true);
        const unlockResult = await organizationService.blockAndDeleteOrg(props?.API, orgId, 'UNLOCK', currentUserDetail.id);
        handleResponseUnlockOrBlock(unlockResult, orgId, Constant.CORPORATION_ACTIVE.ACTIVE);
        setIsLoading(false);
    };

    const onSubmitBlockOrg = async () => {
        setIsPopupConfirmBlock(false);
        setIsLoading(true);
        const orgId = clickedOrg;
        const blockResult = await organizationService.blockAndDeleteOrg(props?.API, orgId, 'BLOCK', currentUserDetail.id);
        handleResponseUnlockOrBlock(blockResult, orgId, Constant.CORPORATION_ACTIVE.BLOCK);
        setIsLoading(false);
    };

    const handleResponseUnlockOrBlock = (result, orgId, corpStatus) => {
        if (isResponseError(result)) {
            setIsShowPopUpReload({
                isOpen: true,
                message: 'COMMSG030'
            });
        } else {
            enqueueSnackbar(buildSnackbarMessage('COMMSG045'), {
                variant: 'success',
                autoHideDuration: 3000,
            });
            updateStatusAfterUpdateActiveStatusOrg(orgId, corpStatus);
            setReloadEditContractTabId(orgId)
            setClickedOrg('');
        }
    }

    const updateStatusAfterUpdateActiveStatusOrg = (orgId,newStatusActive) =>{
        let orgListClone = [...orgList];
        const index = orgListClone.findIndex(org => org.id === orgId);
        const groupOrg = orgListClone.find(org => {
            if (!Utils.isEmptyArray(org?.groupPartnerOrSp)) {
                const findOrg = org?.groupPartnerOrSp.find(child => child.id == orgId);
                if (!Utils.isEmptyObject(findOrg)) {
                    return org;
                }
            }
        });
        let orgUpdated = orgListClone[index];
        if (index == -1 && !Utils.isEmptyArray(groupOrg?.groupPartnerOrSp)) {
            const indexNew = groupOrg?.groupPartnerOrSp.findIndex(org => org.id === orgId);
            orgUpdated = groupOrg?.groupPartnerOrSp[indexNew];
        }
        orgUpdated.active = newStatusActive
        setOrgList([...orgListClone])
    }

    const updateListOrgAfterDeleteOrg =(orgId) => {
        let orgListClone = orgList?.filter(org => {
            if (org?.groupPartnerOrSp && !Utils.isEmptyArray(org?.groupPartnerOrSp)) {
                const findIndexOrg = org?.groupPartnerOrSp.findIndex(child => child.id == orgId);
                if (findIndexOrg > -1) {
                    org?.groupPartnerOrSp.splice(findIndexOrg, 1);
                }
            }

            return org.id !== orgId;
        })
        setOrgList([...orgListClone]) 
    }

    const updatePermissionOrgAfterChangeRoot = (newValue) => {
        let orgListClone = [...orgList];
        const index = orgListClone.findIndex(org => org.id === newValue.id);
        let orgUpdated = orgListClone[index];
        orgUpdated.rootFlag = newValue.rootFlag
        setOrgList([...orgListClone])
    }

    const isDisableChangeRootOrg = (org) => {
        if (org.active !== Constant.CORPORATION_ACTIVE.ACTIVE) {
            return true
        }
        if ([Constant.CORPORATION_CONTRACT_TYPE.GUEST, Constant.CORPORATION_CONTRACT_TYPE.GUEST_DESK].includes(org.contractType)) {
            return true
        }
        return org.id === corporationDetail.id;
    }

    const renderTblUserList = () => {
        let listItems = orgList?.map((org, i) => (
            <Fragment key={org.id}>
                <TableRow className={isDisplayWarningIcon(org) ? 'warning-quota' : ''}>
                    <TableCell>    
                        <div className="table--column-org-logo">
                            <div className="fixed-with-logo">
                                <img className="img-list-org-logo" src={org.corporationLogo} alt="" />
                            </div>
                        </div>
                    </TableCell>
                    <TableCell>
                        <div className="list-org-name">
                            <div className='org-name'>
                                <OverFlowTooltipWithCustomCss
                                    value={Utils.getTextByLanguage(Constant.LANGUAGE_TYPE.JP, org.name)}
                                    onClick={e => {
                                        addNewTab(
                                            org.id,
                                            Utils.getTextByLanguage(Constant.LANGUAGE_TYPE.JP, org.name)
                                        );
                                    }}
                                    style={customStyle}
                                />
                                {tr(`${displayContractStatus(org?.contractStatus)}`)}
                            </div>
                            {isDisplayWarningForContractStatus(org?.contractStatus) && <div className='warning-setting'>
                                <img src="/assets/image/error.png" alt="" />
                            </div>}
                        </div>
                    </TableCell>
                    <TableCell>
                        <div className={`user-status user-status-${getOrgStatus(org).toLowerCase()}`}>
                            {tr(getOrgStatus(org))}
                        </div>
                    </TableCell>
                    <TableCell className='text-center'>
                        <div className="switch-check">
                            <input
                                type="checkbox"
                                id="rootFlag"
                                checked={org.rootFlag}
                                disabled={isDisableChangeRootOrg(org)}
                                readOnly
                            />
                            <label
                                onClick={e => onClickChangePermission(org)  }
                            >
                                <span className="switch-text"></span>
                            </label>
                        </div>
                    </TableCell>
                    <TableCell className='text-left'>
                        <IconButton onClick={e => handleClickShareStatus(e, org, setMoreAction, setOpenShareStatusPopover)}>
                            <img src="/assets/image/icon-nav-tabs.svg" alt="" />
                        </IconButton>
                        {!Utils.isEmptyArray(org?.groupPartnerOrSp) && (<IconButton onClick={e => handleClickExpand(e, org.id, openGroupPartnerOrSp, setOpenGroupPartnerOrSp)}>
                            <img
                                src="/assets/image/icon-arrow-nav.svg"
                                style={{ transform: openGroupPartnerOrSp === org.id ? 'rotate(180deg)' : 'rotate(0)' }}
                                alt=''
                            />
                        </IconButton>)}
                        {
                            corporationDetail.id !== org.id && org.rootFlag !== 1 && 
                            <MoreActionListOrg
                                org={org}
                                moreAction={moreAction}
                                setMoreAction={setMoreAction}
                                onClickUnlockOrg={onClickUnlockOrg}
                                onClickBlockOrg={onClickBlockOrg}
                                onClickDeleteOrg={onClickDeleteOrg}
                                popoverId={org.id}
                                openShareStatusPopover={openShareStatusPopover}
                            />
                        }
                    </TableCell>
                </TableRow>
                {org?.groupPartnerOrSp && !Utils.isEmptyArray(org?.groupPartnerOrSp) && (<TableRow>
                    <TableCell style={{ padding: 0 }} colSpan={5}>
                        <CollapseListOrg
                            org={org}
                            customStyle={customStyle}
                            moreAction={moreAction}
                            setMoreAction={setMoreAction}
                            onClickUnlockOrg={onClickUnlockOrg}
                            onClickBlockOrg={onClickBlockOrg}
                            onClickDeleteOrg={onClickDeleteOrg}
                            openShareStatusPopover={openShareStatusPopover}
                            setOpenShareStatusPopover={setOpenShareStatusPopover}
                            openGroupPartnerOrSp={openGroupPartnerOrSp}
                            addNewTab={addNewTab}
                        />
                    </TableCell>
                </TableRow>)}
            </Fragment>
        ));
        let tbl = (
            <div className="table-tbl table-tbl--account">
                <Table
                    data-cy="system-user-list-table"
                    style={{ borderCollapse: 'separate', borderSpacing: 0 }}
                >
                    <TableRow>
                        <TableCell id="org-logo" align="left">
                        {tr('組織ロゴ')}
                        </TableCell>
                        <TableCell id="org-name" align="left">
                        {tr('組織名')}
                        </TableCell>
                        <TableCell id="org-status" align="left">
                        {tr('ステータス')}
                        </TableCell>
                        <TableCell className='text-center' id="root-authen" align="left">
                        {tr('Root権限')}
                        </TableCell>
                        <TableCell className='text-left' id="action" align="left">
                        {tr('操作')}
                        </TableCell>
                    </TableRow>
                    {/* add corp */}
                    <TableBody>{listItems}</TableBody>
                </Table>
            </div>
        );
        return tbl;
    };
    return (
        <div className="groupUser">
            <LoadingPanel isLoading={isLoading} />
            <div className="head-btn">
                <div className="head-btn-add">
                    <div className="headName">{tr('組織一覧')}</div>
                </div>
            </div>
            <div className="group-user">
                <div className="user-table">{renderTblUserList()}</div>
            </div>
            <ConfirmDialog
                isOpen={isOpenPopupConfirmBlock}
                msgConfirm={trI18n('USER14MSG002')}
                closeCallBack={() => {
                    setClickedOrg('')
                    setIsPopupConfirmBlock(false);
                }}
                okCallBack={onSubmitBlockOrg}
                textSubmit={tr('はい')}
                textClose={tr('いいえ')}
            />
            <ConfirmDialog
                isOpen={isOpenPopupConfirmUnlock}
                msgConfirm={trI18n('USER14MSG003')}
                closeCallBack={() => {
                    setClickedOrg('')
                    setIsPopupConfirmUnlock(false);
                }}
                okCallBack={onSubmitUnlockOrg}
                textSubmit={tr('はい')}
                textClose={tr('いいえ')}
            />
            <ConfirmDialog
                isOpen={isOpenPopupConfirmDelete}
                msgConfirm={trI18n('USER14MSG001')}
                closeCallBack={() => {
                    setClickedOrg('')
                    setIsOpenPopupConfirmDelete(false);
                }}
                okCallBack={onSubmitDeleteOrg}
                textSubmit={tr('はい')}
                textClose={tr('いいえ')}
            />
            <ConfirmDialog
                isOpen={isOpenPopupCantNotDelete}
                msgConfirm={trI18n('USER14MSG001-1')}
                okCallBack={() => {
                    setClickedOrg('')
                    setIsOpenPopupCantNotDelete(false);
                }}
                textSubmit={tr('はい')}
                textClose={tr('いいえ')}
            />
            <ConfirmDialog
                isOpen={isOpenPopupConfirmOffRootOrg}
                msgConfirm={trI18n('USER14MSG027')}
                closeCallBack={() => {
                    setClickedOrg('')
                    setIsPopupConfirmOffRootOrg(false);
                }}
                okCallBack={onSubmitChangeRootFlag}
                textSubmit={tr('はい')}
                textClose={tr('いいえ')}
            />
            <ConfirmDialog
                isOpen={isOpenPopupConfirmOnRootOrg}
                msgConfirm={trI18n('USER14MSG026')}
                closeCallBack={() => {
                    setClickedOrg('')
                    setIsPopupConfirmOnRootOrg(false);
                }}
                okCallBack={onSubmitChangeRootFlag}
                textSubmit={tr('はい')}
                textClose={tr('いいえ')}
            />
            <ConfirmDialog
                isOpen={isShowPopUpReload.isOpen}
                msgConfirm={
                    isShowPopUpReload?.message
                        ? trI18n(isShowPopUpReload?.message)
                        : trI18n('COMMSG030')
                }
                okCallBack={() => window.location.reload()}
            />
        </div>
    );
}
